import { createFileRoute } from '@tanstack/react-router';
import { BlacklistedCarriers } from '@uturn/portal/modules/org/pages/blacklisted-carriers';

export const Route = createFileRoute(
	'/_protected/org/$orgId/settings/blacklisted-carriers',
)({
	component: BlacklistedCarriers,
});
